import Joi from "joi";

export const customerSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  isDefault: Joi.boolean().label("Is Default"),
  code: Joi.string().min(2).label("Code"),
  contractTerms: Joi.string().min(2).label("Contract Terms"),
  companyId: Joi.string().invalid("00000000-0000-0000-0000-000000000000").min(2).required().label("Company"),
  phoneNo: Joi.string()
    .pattern(/^\+?[1-9]\d{6,14}$/)
    .label("Phone No")
    .messages({
      "string.pattern.base": "Phone should look like +38344111222",
    }),
});
